module.exports = __webpack_public_path__ + "images/root/mainVisual_bgImage_bottom_sp_213a1c0e271be7db3ab3a2739207d577.gif";